export default "__VITE_ASSET__Dph7G0Pk__"